<template>
  <button class="note-row" @click="onClick">
    <Row :class="computedClass" has-interaction>
      <template #top-left>
        {{ brokerageNote.date.formatted }}
      </template>
      <template #icon-right>
        <LoaderIndicator v-if="loading" size="24" />
        <BaseIcon v-else icon="EA0230" :colors="iconColor" />
      </template>
    </Row>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { BaseIcon, Row, LoaderIndicator } from '@warrenbrasil/nebraska-web';

import { PortfolioBrokerageNote } from '@/modules/wealth/services/portfolio';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  brokerageNote: PortfolioBrokerageNote;
  disabled: boolean;
  loading: boolean;
}
const props = defineProps<Props>();

interface Emits {
  (event: 'on-click'): void;
}
const emit = defineEmits<Emits>();

const computedClass = computed(() => {
  return {
    'note-row--default': true,
    'note-row--disabled': props.disabled,
    'note-row--loading': props.loading
  };
});

const iconColor = computed(() => {
  return props.disabled || props.loading
    ? NebraskaColors.elementDisabled
    : NebraskaColors.elementSecondary;
});

const onClick = () => {
  if (props.disabled || props.loading) return;
  emit('on-click');
};
</script>

<style lang="less" scoped>
.note-row {
  display: block;
  width: 100%;
  padding: 0;

  &--default {
    color: @element-secondary;
    background: transparent;
  }

  &--disabled,
  &--loading {
    color: @element-disabled !important;
    cursor: not-allowed !important;
  }
}
</style>
